import { thru } from "./function";
export { thru };
export function thruUnlessF(val, handle) {
    if (!val)
        return null;
    return handle(val);
}
export function thruUnlessN(val, handle) {
    if (val == null)
        return null;
    return handle(val);
}
export function thruUnlessAnyN(vals, handle) {
    if (vals.find(_ => _ == null))
        return null;
    return handle(vals);
}
export function thruIf(val, cond, process) {
    if (cond(val))
        return process(val);
    return null;
}
//# sourceMappingURL=nullability.js.map